<template>
	<div class="w-full">
		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="4" vs-sm="12" class="text-left">
				<Default :index="index" :label="$t('MODULE.typeFont')"></Default>
			</vs-col>
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="4" vs-sm="12" class="text-left">
				<Number v-model="questionsByPage[index].properties.size" :min="1" :max="30" :label="$t('MODULE.lengthFont')"></Number>
			</vs-col>
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="4" vs-sm="12" class="text-left">
				<Color :index="index"></Color>
			</vs-col>
		</vs-row>
		<vs-textarea class="mt-4" :label="$t('MODULE.textiewLabel')" v-model="questionsByPage[index].content" />
	</div>
</template>
<script type="text/javascript">
	import Default from '../../componentsToQuestions/DefaultSelect.vue';
	import Number from '../../components/Number.vue';
	import Color from '../../componentsToQuestions/Color.vue';

	import { mapState } from 'vuex';
	
	export default {
		components: { Default, Number, Color },
		props: ['index'],
		computed: {
			...mapState('resource',['questionsByPage']),
		}

	}
</script>